import { createElement } from "../SchemaSettings";
import { Theme1 } from "./Themes/Theme1";

export const ThemeRegistry = {
 theme1:Theme1
};


export const samplePage = {
  id: "page-1",
  sections: [
    {
      id: "section1732157000000",
      layoutRole: "hero",
      visible: true,
      order: 0,
      contents: [
        {
          id: "con-1732157001001",
          layoutRole: "column",
          order: 0,
          visible: true,
          cards: [
            {
              id: "crd-1732157002002",
              componentType: "heroCard",
              order: 0,
              visible: true,
              elements: [
                 createElement({ id: "header-1", type: "header", content: "🚀 Launch", styleRole: "heading" }),
                     
                {
                  id: "el-1732157003010",
                  type: "para",
                  styleRole: "body",
                  content: "This platform is awesome!",
                  visible: true,
                  styles: {
                    default: {},
                    theme: {},
                    custom: {}
                  }
                },
                {
                  id: "el-1732157003015",
                  type: "btn",
                  styleRole: "button",
                  content: "Get Started",
                  visible: true,
                  styles: {
                    default: {},
                    theme: {},
                    custom: {}
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};


export const StyleRoleMap = {
  header: "heading",
  title: "heading",
  para: "body",
  label: "label",
  btn: "button",
  icon: "icon",
};

